import React, { useEffect, useState } from "react";
import { Menu } from "antd";
import { NotificationModules } from "../../constants/Constants";
import { getNotificationsByRefId } from "./actions/notificationsService";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";

export default function NotificationItem({ keyProp, notification }) {
  const [moduleInformation, setModuleInformation] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    setModuleInformation(NotificationModules);
  }, [notification]);
  function handleNotificationClick() {
    const showModal =
      notification.taskDetails["status"] === "Fail" ? true : false;
    if (showModal)
      dispatch(getNotificationsByRefId(notification.refId)); //if error
    else {
      //if success
      if (
        window.location.pathname ===
        moduleInformation[notification.taskDetails["moduleName"]][
          notification.taskDetails["status"]
        ]["route"]
      ) {
        window.location.reload();
      } else {
        navigate(
          moduleInformation[notification.taskDetails["moduleName"]][
            notification.taskDetails["status"]
          ]["route"]
        );
      }
    }
  }
  return (
    <div
      className="notification-item"
      style={{
        backgroundColor: moduleInformation
          ? moduleInformation[notification.taskDetails["moduleName"]][
              notification.taskDetails["status"]
            ]["color"]
          : "none",
      }}
    >
      <span data-testid={`module-name-${keyProp}`}>
        {notification.taskDetails["moduleName"]}
      </span>
      <div className="notification-message">
        <Menu.Item
          key={String(keyProp)}
          onClick={() => handleNotificationClick()}
        >
          {notification.taskDetails["message"]}
        </Menu.Item>
        <span data-testid={`notification-date-${keyProp}`}>
          {notification.createdDate}
        </span>
      </div>
    </div>
  );
}
